import { catchNotAPIErrors, configurationCookiesConfig, setUssidToCookies } from 'src/common/functions'
import getFullCheck from 'src/apollo/queries/getFullCheck.gql'
import { CONFIG } from 'src/common/config'
import { Cookies } from 'quasar'
import sessionAuth from 'src/apollo/mutations/sessionAuth.gql'
import { TokenService } from 'src/common/token-service'
import * as Sentry from '@sentry/vue'

export async function authBySession(store, apolloClient) {
  const clearUser = (num) => {
    if (Cookies.has('debug-7878')) {
      console.log('clearUser: ', num)
    }
    if (Cookies.has('ussidcs')) {
      store.$axios.auth.removeSession()
    }
  }

  let token = Cookies.get('token')
  let ussidD = Cookies.get('ussid-d')
  let underAttack = true
  const isWebView = store.getters['isWebView']

  await apolloClient
    .query({
      query: getFullCheck,
    })
    .then(({ data }) => {
      underAttack = data.siteInfo.fullCheck
      store.commit('UPDATE_FULL_CHECK', data.siteInfo.fullCheck)
    })

  if (ussidD && token) {
    const configCookies = configurationCookiesConfig(token, CONFIG.COOKIES_OPTIONS)
    Cookies.remove('ussid-d', CONFIG.COOKIES_OPTIONS)
    setUssidToCookies(ussidD, configCookies.expires)
  }

  if (!token && !isWebView) {
    let session = null

    try {
      const { data } = await store.$axios.auth.getSession()
      if (data?.ussidcs) {
        session = data.ussidcs
        localStorage.setItem('ussidcs-tmp', session)
      }
    } catch (e) {
      localStorage.removeItem('ussidcs-tmp')
    }

    if (session) {
      if (!underAttack) {
        localStorage.removeItem('ussidcs-tmp')

        const captcha = await grecaptcha.execute(process.env.RECAPTCHA_ID, { action: 'session_login' })

        apolloClient
          .mutate({
            mutation: sessionAuth,
            variables: {
              session,
              captcha,
            },
          })
          .then(({ data }) => {
            const { sessionAuth } = data
            const configCookies = configurationCookiesConfig(sessionAuth.token, CONFIG.COOKIES_OPTIONS)

            const tokenService = new TokenService()
            tokenService.setToken(sessionAuth.token, sessionAuth.ussid)

            if (sessionAuth.ussid) {
              setUssidToCookies(sessionAuth.ussid, configCookies.expires)
            }

            if (sessionAuth.user?.language) {
              localStorage.setItem('u_lang', sessionAuth.user.language)
            }

            store.dispatch('updateToken', sessionAuth.token)
            store.dispatch('updateAuth', true)
            store.dispatch('updateUser', sessionAuth.user)
            Sentry.setUser({ username: sessionAuth.user.username, email: sessionAuth.user.email })

            return true
          })
          .catch((e) => {
            catchNotAPIErrors(e, 'auth-by-session boot')
            clearUser(1)
          })

        return false
      }
      return false
    }

    clearUser(2)
    return false
  }

  return false
}
